import get from 'lodash/get';
import { createSelector } from 'reselect/lib/index';

export const usersJoinRequestsSelector = state =>
  get(state, 'communities.usersJoinRequests');

export const usersJoinRequestsListSelector = createSelector(
  usersJoinRequestsSelector,
  request => get(request, 'list', []),
);

export const usersJoinRequestsCounterSelector = createSelector(
  usersJoinRequestsSelector,
  request => get(request, ['meta', 'requestsCount'], 0),
);

export const usersJoinRequestsPaginationSelector = createSelector(
  usersJoinRequestsSelector,
  state => get(state, 'pagination', {}),
);



// WEBPACK FOOTER //
// ./src/redux/communities/selectors/usersJoinRequests.js